'use strict';

var StrategyReadonlyClosureActionsDirective = function StrategyReadonlyClosureActionsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-readonly-closure-actions.html'),
    controller: 'StrategyReadonlyClosureActionsController',
    scope: {
      strategyActions: '='
    }
  };
};
StrategyReadonlyClosureActionsDirective.$inject = [];
module.exports = StrategyReadonlyClosureActionsDirective;